import { DataSourceType, GetClientFlags200Response } from "@coeff/api";

export const DataSourceTypeDisplayNames: { [dsType in DataSourceType]: string } = {
  csv: "CSV",
  any_api_agent: "Any API (Agent)",
  browser_agent: "Browser Agent",
  google_sheets: "Google Sheets",
  salesforce: "Salesforce",
  mysql: "MySQL",
  redshift: "Redshift",
  postgres: "PostgreSQL",
  aurora_postgres: "Aurora PostgreSQL",
  aurora_mysql: "Aurora MySQL",
  cloud_sql_postgres: "Cloud SQL for PostgreSQL",
  cloud_sql_mysql: "Cloud SQL for MySQL",
  supabase: "Supabase",
  neon: "Neon",
  timescaledb: "TimescaleDB",
  azure_postgres: "Azure PostgreSQL",
  azure_mysql: "Azure MySQL",
  azure_sql: "Azure SQL (SQL Server)",
  clickhouse: "ClickHouse",
  motherduck: "MotherDuck",
  snowflake: "Snowflake",
  mssql: "MS SQL Server",
  bigquery: "BigQuery",
  looker: "Looker",
  chargebee: "Chargebee",
  chargify: "Chargify",
  google_analytics: "Google Analytics (UA)",
  google_analytics_4: "Google Analytics 4",
  facebook_ads: "Meta Ads",
  hubspot: "HubSpot",
  marketo: "Marketo",
  netsuite: "NetSuite",
  netsuite_crx: "NetSuite Agent",
  quickbooks: "QuickBooks",
  shopify: "Shopify",
  stripe: "Stripe",
  tableau: "Tableau",
  jira: "Jira",
  zendesk: "Zendesk",
  google_drive: "Google Drive",
  amplitude: "Amplitude",
  airtable: "Airtable",
  gong: "Gong",
  klaviyo: "Klaviyo",
  mailchimp: "Mailchimp",
  mongodb: "Mongodb",
  outreach: "Outreach",
  pipedrive: "Pipedrive",
  sendgrid: "Sendgrid",
  excel: "Excel",
  one_drive: "One Drive",
  sharepoint_lists: "SharePoint Lists",
  box: "Box",
  egnyte: "Egnyte",
  gmail: "Gmail",
  google_search_console: "Google Search Console",
  google_ads: "Google Ads",
  notion: "Notion",
  greenhouse: "Greenhouse",
  xero: "Xero",
  custom_api: "Connect Any API",
  web_scraper: "Web Scraper",
  gpt_copilot: "GPT Co-pilot",
  cloud_table: "Cloud Table",
  linkedin: "LinkedIn",
  linkedin_ads: "LinkedIn Ads",
  facebook_insights: "Facebook Insights",
  instagram_insights: "Instagram Insights",
  linkedin_pages: "LinkedIn Pages",
  youtube_analytics: "YouTube Analytics",
  microsoft_ads: "Microsoft Ads",
  asana: "Asana",
  razorpay: "Razorpay",
  clickup: "ClickUp",
  typeform: "Typeform",
  harvest: "Harvest",
  freshdesk: "Freshdesk",
  paymo: "Paymo",
  google_calendar: "Google Calendar",
  amazon_seller_central: "Amazon Seller Central",
  trello: "Trello",
  calendly: "Calendly",
  smartsheet: "Smartsheet",
  quora_ads: "Quora Ads",
  reddit_ads: "Reddit Ads",
  surveymonkey: "SurveyMonkey",
  podio: "Podio",
  gusto: "Gusto",
  intercom: "Intercom",
  etsy: "Etsy",
  pinterest_ads: "Pinterest Ads",
  active_campaign: "ActiveCampaign",
  basecamp: "Basecamp",
  jotform: "Jotform",
  zohobooks: "Zoho Books",
  zohobooks_ai: "Zoho Books",
  coda: "Coda",
  square: "Square",
  zoom: "Zoom",
  webflow: "Webflow",
  bigin: "Bigin",
  bigin_ai: "Bigin",
  zoho_crm: "Zoho CRM",
  zoho_crm_ai: "Zoho CRM",
  lever: "Lever",
  salesloft: "Salesloft",
  woo_commerce: "WooCommerce",
  wordpress: "WordPress",
  bigcommerce: "BigCommerce",
  smartlead: "Smartlead",
  affinity: "Affinity",
  shiprocket: "Shiprocket",
  databricks: "Databricks SQL",
  arrow_flight_sql: "Arrow Flight SQL",
  rippling: "Rippling",
  apollo: "Apollo",
  apollo_ai: "Apollo",
  freshdesk_ai: "Freshdesk",
  greenhouse_ai: "Greenhouse",
  trello_ai: "Trello",
  jotform_ai: "Jotform",
  coda_ai: "Coda",
  typeform_ai: "Typeform",
  podio_ai: "Podio",
  smartsheet_ai: "Smartsheet",
  basecamp_ai: "Basecamp",
  metabase_ai: "Metabase",
  teamwork_ai: "Teamwork",
  cats_ats_ai: "CATS ATS",
  nutshell_ai: "Nutshell",
  pipeliner_ai: "Pipeliner CRM",
  salesflare_ai: "Salesflare",
  vtiger_crm_ai: "VTiger CRM",
  freshservice_ai: "Freshservice",
  hive_ai: "Hive",
  aircall_ai: "Aircall",
  nimble_crm_ai: "Nimble CRM",
  drip_ai: "Drip",
  paddle_ai: "Paddle",
  agile_crm_ai: "Agile CRM",
  checkout_ai: "Checkout.com",
  capsule_ai: "Capsule CRM",
  bitbucket_ai: "Bitbucket",
  gitlab_ai: "GitLab",
  helpscout_ai: "Help Scout",
  front_ai: "Front",
  wrike_ai: "Wrike",
  bamboohr_ai: "BambooHR",
  deel_ai: "Deel",
  confluence_ai: "Confluence",
  teamleader_ai: "Teamleader",
  miro_ai: "Miro",
  omnisend_ai: "Omnisend",
  attio_ai: "Attio",
  creatio_ai: "Creatio",
  freeagent_ai: "FreeAgent",
  moneybird_ai: "Moneybird",
  accelo_ai: "Accelo",
  applicantstack_ai: "ApplicantStack",
  aloware_ai: "Aloware",
  stackby_ai: "Stackby",
  float_ai: "Float",
  clickhouse_ai: "ClickHouse",
  appsflyer_ai: "AppsFlyer",
  mariadb_ai: "MariaDB",
  launchdarkly_ai: "LaunchDarkly",
  posthog_ai: "PostHog",
  dovetail_ai: "Dovetail",
  shipstation_ai: "ShipStation",
  mindbody_ai: "Mindbody",
  groww_ai: "Groww",
  amazon_seller_central_ai: "Amazon Seller Central",
  airwallex_ai: "Airwallex",
  statsig_ai: "Statsig",
  modern_treasury_ai: "Modern Treasury",
  rudderstack_ai: "RudderStack",
  bright_data_ai: "Bright Data",
  vwo_ai: "VWO",
  partnerize_ai: "Partnerize",
  rillet_ai: "Rillet",
  trolley_ai: "Trolley",
  scalefusion_ai: "Scalefusion",
  baremetrics_ai: "Baremetrics",
  todoist_ai: "Todoist",
  workable_ai: "Workable",
  plausible_ai: "Plausible",
  apify_ai: "Apify",
  datascope_ai: "DataScope",
  gorgias_ai: "Gorgias",
  everhour_ai: "Everhour",
  exchangerates_ai: "Exchange Rates",
  fastbill_ai: "FastBill",
  glassfrog_ai: "GlassFrog",
  resource_flow_hubplanner_ai: "Resource Flow",
  katana_ai: "Katana",
  myhours_ai: "My Hours",
  fis_railz_ai: "FIS (Railz)",
  tellent_hris_ai: "Tellent (HRIS)",
  simfin_ai: "SimFin",
  smartwaiver_ai: "Smartwaiver",
  lokalise_ai: "Lokalise",
  mailerlite_ai: "MailerLite",
  mailersend_ai: "MailerSend",
  onesignal_ai: "OneSignal",
  postmark_ai: "Postmark",
  short_io_ai: "Short.io",
  yotpo_ai: "Yotpo",
  chartmogul_ai: "ChartMogul",
  configcat_ai: "ConfigCat",
  pingdom_ai: "Pingdom",
  retently_ai: "Retently",
  coinmarketcap_ai: "CoinMarketCap",
  softr_io_ai: "Softr",
  emailoctopus_ai: "EmailOctopus",
  gridly_ai: "Gridly",
  mixmax_ai: "Mixmax",
  reply_io_ai: "Reply.io",
  less_annoying_crm_ai: "Less Annoying CRM",
  snov_io_ai: "Snov.io",
  onepagecrm_ai: "OnePageCRM",
  lemlist_ai: "Lemlist",
  sage: "Sage Intacct",
  aws_billing: "AWS Billing",
  google_classroom: "Google Classroom",
  chargebee_ai: "Chargebee",
  stripe_ai: "Stripe",
  outreach_ai: "Outreach",
  clickup_ai: "ClickUp",
  jira_ai: "Jira",
  square_ai: "Square",
  expensify_ai: "Expensify",
  twilio_ai: "Twilio",
  sendgrid_ai: "SendGrid",
  campfire: "Campfire",
  rillet: "Rillet",
  netflix_quiver: "Netflix Metrics",
  kit_ai: "Kit",
  insightly_ai: "Insightly",
  freshsales_ai: "Freshsales",
  close_ai: "Close",
  xero_ai: "Xero",
  mode_ai: "Mode",
  monday_ai: "Monday.com",
  mixpanel_ai: "Mixpanel",
  clockify_ai: "Clockify",
  kobotoolbox_ai: "KoboToolbox",
  toggl_track_ai: "Toggl Track",
  smartsuite_ai: "SmartSuite",
  odoo_ai: "Odoo",
  linear_ai: "Linear",
  klaviyo_ai: "Klaviyo",
  razorpay_ai: "Razorpay",
  paymo_ai: "Paymo",
  active_campaign_ai: "ActiveCampaign",
  wordpress_ai: "WordPress",
  woo_commerce_ai: "WooCommerce",
  smartlead_ai: "Smartlead",
  shiprocket_ai: "Shiprocket",
  rippling_ai: "Rippling",
  harvest_ai: "Harvest",
  calendly_ai: "Calendly",
};

export const getMaskedConnectionString = (connectionStr: string | undefined): string => {
  try {
    if (connectionStr === undefined) {
      return "*****";
    }
    if (String(connectionStr).includes("jdbc:databricks")) {
      const passwordToMask = connectionStr.substring(connectionStr.lastIndexOf("PWD=") + 4);
      // @ts-ignore
      return connectionStr.replaceAll(passwordToMask, "*****");
    }
    if (!String(connectionStr).includes("mongodb+srv")) {
      return String(connectionStr);
    }
    // @ts-ignore
    const usernamePass = connectionStr.match(/mongodb\+srv:\/\/([^@]+)/)[1];
    const passwordToMask = usernamePass.substring(usernamePass.lastIndexOf(":") + 1);
    // @ts-ignore
    return connectionStr.replaceAll(passwordToMask, "*****");
  } catch (error) {
    return "*****";
  }
};
